import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import GdsRcptTrackingReportActions, {
  GdsRcptTrackingReportTypes
} from '../Stores/GdsRcptTrackingReport/Actions';

const getAppStore = state => state.app;

export function* gdsRcptTrackingReportInitGdsRcptTracking() {
  try {
    yield put(GdsRcptTrackingReportActions.gdsRcptTrackingReportReportLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `salesReport/initGdsRcptTracking/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        GdsRcptTrackingReportActions.gdsRcptTrackingReportInitGdsRcptTrackingSuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GdsRcptTrackingReportActions.gdsRcptTrackingReportReportLoading(false));
  }
}

export function* gdsRcptTrackingReportGdsRcptTracking({ formikBag, criteria }) {
  try {
    formikBag.setSubmitting(true);
    yield put(GdsRcptTrackingReportActions.gdsRcptTrackingReportReportLoading(true));

    const objCriteria = {};
    if ('start_date' in criteria) {
      objCriteria.start_date = criteria.start_date;
    }
    if ('end_date' in criteria) {
      objCriteria.end_date = criteria.end_date;
    }
    if ('division_ids_select2' in criteria) {
      const values = criteria.division_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.division_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('biz_partner_ids_select2' in criteria) {
      const values = criteria.biz_partner_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.biz_partner_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('debtor_ids_select2' in criteria) {
      const values = criteria.debtor_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.debtor_ids = values.map(entry => {
          return entry.value;
        });
      }
    }

    let columns = [];
    if (criteria.columns.target.length > 0) {
      columns = criteria.columns.target.map(entry => {
        return entry.column;
      });
    }

    const app = yield select(getAppStore);
    const postData = {
      sorts: [],
      criteria: objCriteria,
      columns
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `salesReport/gdsRcptTracking/${app.curSiteFlowId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(
        GdsRcptTrackingReportActions.gdsRcptTrackingReportGdsRcptTrackingSuccess(
          criteria,
          result.data.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(GdsRcptTrackingReportActions.gdsRcptTrackingReportReportLoading(false));
  }
}

export function* gdsRcptTrackingReportFetchDivisionOptions({ search }) {
  try {
    yield put(GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchDivisionOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `division/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.name_01}`
      }));

      yield put(
        GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchDivisionOptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchDivisionOptionLoading(false));
  }
}

export function* gdsRcptTrackingReportFetchBizPartnerOptions({ search }) {
  try {
    yield put(GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchBizPartnerOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `bizPartner/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.company_name_01}`
      }));

      yield put(
        GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchBizPartnerOptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchBizPartnerOptionLoading(false)
    );
  }
}

export function* gdsRcptTrackingReportFetchDebtorOptions({ search }) {
  try {
    yield put(GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchDebtorOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      debtorType: 1, // 0 = normal, 1 = principal
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `debtor/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.company_name_01} ${d.company_name_02}`
      }));

      yield put(
        GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchDebtorOptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GdsRcptTrackingReportActions.gdsRcptTrackingReportFetchDebtorOptionLoading(false));
  }
}

export const saga = [
  takeLatest(
    GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_INIT_GDS_RCPT_TRACKING,
    gdsRcptTrackingReportInitGdsRcptTracking
  ),
  takeLatest(
    GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_GDS_RCPT_TRACKING,
    gdsRcptTrackingReportGdsRcptTracking
  ),

  takeLatest(
    GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_FETCH_DIVISION_OPTIONS,
    gdsRcptTrackingReportFetchDivisionOptions
  ),
  takeLatest(
    GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_FETCH_BIZ_PARTNER_OPTIONS,
    gdsRcptTrackingReportFetchBizPartnerOptions
  ),

  takeLatest(
    GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_FETCH_DEBTOR_OPTIONS,
    gdsRcptTrackingReportFetchDebtorOptions
  )
];
